<template>
  <div class="text-center">
    <p>{{ params.data.patient.gender == 'female' ? 'F' : 'M' }}</p>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  methods: {

  },
  computed: {
    url () {
      return '/patients/patient/view/'+this.params.data.patient.id

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
